<template>
    <div>
        <k-container background="bg-white" class="shadow-sm border-b border-gray-300">
            <nav class="py-4">
                <div class="flex items-center flex-wrap">
                    <div class="flex-grow mr-4">
                        <a :href="landingUrl">
                            <img src="/img/kilde_logo.png" style="max-width: 114px;">
                        </a>
                    </div>
                    <div class="flex text-sm font-base leading-tight flex-row py-0 pl-4 md:py-4">
                        <router-link class="block self-center" to="/login"
                                     v-if="!$root.$authToken()">
                            <k-button size="sm" :block="true">{{ $t("logIn") }}</k-button>
                        </router-link>
                        <router-link class="block self-center" :to="'logout'" v-if="$root.$authToken()">
                            <img src="/img/logout.svg" class="inline">
                        </router-link>
                    </div>
                </div>
            </nav>
        </k-container>
    </div>
</template>

<script>
export default {
    data() {
        return {
            landingUrl: null,
            itemsVisible: false
        }
    },
    mounted() {
        this.landingUrl = process.env.VUE_APP_KILDE_LENDING_BASE_URL
    },
    methods: {
        toggleMenu() {
            this.itemsVisible = !this.itemsVisible
        }
    }
}
</script>

